import isDisabled from "./isDisabled";
import propsToAccessibilityComponent from "./propsToAccessibilityComponent";
import propsToAriaRole from "./propsToAriaRole";
const AccessibilityUtil = {
  isDisabled,
  propsToAccessibilityComponent,
  propsToAriaRole
};
var AccessibilityUtil_default = AccessibilityUtil;
export {
  AccessibilityUtil_default as default
};
//# sourceMappingURL=index.js.map
